/* eslint-disable react/prop-types */
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment/moment";
import tableStyle from "../../theme/styles/table";
import { style } from "./styles";
// import { getOSCollective } from "../../utils";
import { isEmptyObj } from "../../utils/helper";

function GohonzonBatchAllotment({ member, onBatchSelect }) {
  if (isEmptyObj(member) || isEmptyObj(member.createdByMember)) {
    return null;
  }
  const { createdByMember } = member;
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member.id}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.numberOfApplications || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.areaName || "-"}/ {member.clusterName || "-"}/{" "}
        {member.zoneName || "-"}/ {member.regionName}
      </TableCell>
      <TableCell style={style.Cell}>
        {createdByMember.fullName || "-"} <br />
        on:{" "}
        {/* {member.appliedAt !== null ? moment(member.appliedAt).format("L") : "-"} */}
        {member.createdAt ? moment(member.createdAt).format("DD/MM/YYYY") : "-"}
      </TableCell>
      <TableCell style={style.Cell}>{member.batchStatus || "-"} </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <RemoveRedEyeOutlinedIcon
          style={style.icon}
          onClick={() => onBatchSelect(member.id)}
        />
      </TableCell>
    </TableRow>
  );
}

export default GohonzonBatchAllotment;
